import Http from "../http";

class CabRequestServices {

  static async getAllCabRequests(page,limit,serviceType){
    return Http.get(`/cabrequest?page=${page}&limit=${limit}&serviceType=${serviceType}`);
  }
 
      static async getUserCabRequestById(id,{ page, rowsPerPage }){
        return Http.get(`/cabrequest/${id}?page=${page}&pageSize=${rowsPerPage}`)
      }
    
}
export default CabRequestServices;